module.exports = __webpack_public_path__ + "img/settings_icon.2fc4c874.svg";